import React, { useState, useEffect } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import Navbar1 from "./Navbar";
import { Link } from "react-router-dom";

// Import delle immagini
import collezione from "../assets/home/anellocontopazio.jpeg";
import pietre from "../assets/home/pietre.jpeg";
import crea from "../assets/home/crea.jpg";
import ImageGallery1 from "../assets/home/orecchini-oro .jpeg";
import ImageGallery2 from "../assets/home/cateninainoro-diamante.jpeg";
import ImageGallery3 from "../assets/home/Anello-argentorodiato.jpeg";
import ImageGallery4 from "../assets/home/anelloin-argento.jpeg";
import ImageGallery5 from "../assets/home/anello-orobianco.jpeg";
import ImageGallery6 from "../assets/home/anellocon-topazio.jpeg";
import ImageGallery7 from "../assets/home/argentorodiato.jpeg";
import ImageGallery8 from "../assets/home/Anelloinargento.jpeg";
import Img from "../assets/home/img-chi-siamo.jpg";

const Home = () => {
  const [hoveredItem, setHoveredItem] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    document.querySelectorAll(".gallery-item").forEach((item) => {
      observer.observe(item);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Navbar1 />

      <Container fluid style={{ padding: "0px", position: "relative" }}>
        <video autoPlay muted loop className="background-video" style={{ width: "100%" }} id="video">
          <source src={process.env.PUBLIC_URL + "/assets/video.mp4"} type="video/mp4" />
          Il tuo browser non supporta il tag video.
        </video>
      </Container>

      <section id="about" className="py-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={10} className="text-center">
              <h1 className="about-title" style={{ fontFamily: "Playfair Display, serif", fontSize: "26px" }}>
                ELEGANZA E UNICITA'
              </h1>
              <div
                style={{
                  width: "80px",
                  height: "3px",
                  backgroundColor: "#ccc",
                  margin: "10px auto 0",
                  marginBottom: "20px",
                }}
              ></div>
            </Col>
          </Row>

          {/* Sezione chi siamo */}

          <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
            <Image
              src={Img}
              alt="Starblack"
              fluid
              style={{
                width: "100%",
                maxWidth: "600px",
                height: "auto",
                borderRadius: "20px",
                boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
                transition: "transform 0.3s ease-in-out",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
          </div>

          <div style={{ marginTop: "50px", padding: "40px 20px", backgroundColor: "#f9f9f9", textAlign: "center" }}>
            <h2 style={{ fontFamily: "Playfair Display, serif", color: "#b3870b", marginBottom: "20px" }}>
              La nostra storia
            </h2>
            <p style={{ fontFamily: "Montserrat, sans-serif", color: "#555", maxWidth: "800px", margin: "0 auto" }}>
              Starblack è sinonimo di eccellenza nel mondo dei gioielli di lusso. La nostra passione per le pietre
              preziose e i minerali rari ci guida nella creazione di gioielli esclusivi, rigorosamente Made in Italy.
              Ogni nostra creazione è pensata per esaltare la bellezza dell’uomo e della donna contemporanei, con un
              design elegante e distintivo.
            </p>
          </div>
        </Container>
      </section>
      {/* Section Gallery */}
      <section className="photo-gallery py-5">
        <Container className="mt-4 mb-4">
          <Row>
            {[
              { image: ImageGallery1 },
              { image: ImageGallery2 },
              { image: ImageGallery3 },
              { image: ImageGallery4 },
              { image: ImageGallery5 },
              { image: ImageGallery6 },
              { image: ImageGallery7 },
              { image: ImageGallery8 },
            ].map((item, index) => (
              <Col key={index} xs={12} sm={6} md={3} className="mb-4">
                <div className="gallery-item">
                  <img src={item.image} alt={`Gallery ${index + 1}`} className="gallery-image" />
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      <Row className="justify-content-center">
        <Col md={10} className="text-center">
          <h1 className="about-title" style={{ fontFamily: "Playfair Display, serif", fontSize: "26px" }}>
            I NOSTRI SERVIZI
          </h1>
          <div
            style={{
              width: "80px",
              height: "3px",
              backgroundColor: "#ccc",
              margin: "10px auto 0",
              marginBottom: "20px",
            }}
          ></div>
        </Col>
      </Row>

      {/* sezione servizi */}
      <section className="services-section py-5">
        <Container>
          <Row className="text-center">
            <Col md={4} className="mb-4">
              <div
                className="service-card"
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "20px",
                }}
              >
                <img
                  src={collezione}
                  alt="Collezione"
                  className="service-image img-fluid mb-3"
                  style={{ width: "100%", height: "200px", objectFit: "cover" }}
                />
                <h3 className="service-title" style={{ fontFamily: "Playfair Display, serif" }}>
                  Collezione
                </h3>
                <p>Gioielli raffinati e di alta qualità.</p>
                <Link to="/collection" className="btn btn-outline-dark" style={{ marginTop: "auto" }}>
                  Scopri
                </Link>
              </div>
            </Col>

            <Col md={4} className="mb-4">
              <div
                className="service-card"
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "20px",
                  backgroundColor: "#e8e5df",
                  color: "white",
                }}
              >
                <img
                  src={crea}
                  alt="Crea il tuo Gioiello"
                  className="service-image img-fluid mb-3"
                  style={{ width: "100%", height: "200px", objectFit: "cover" }}
                />
                <h3 className="service-title" style={{ color: "black", fontFamily: "Playfair Display, serif" }}>
                  Crea il tuo Gioiello
                </h3>
                <p style={{ color: "black" }}>Personalizza un gioiello unico.</p>

                <Link to="/CustomJewelryForm" className="btn btn-outline-dark" style={{ marginTop: "auto" }}>
                  Scopri
                </Link>
              </div>
            </Col>

            <Col md={4} className="mb-4">
              <div
                className="service-card"
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "20px",
                }}
              >
                <img
                  src={pietre}
                  alt="Pietre Preziose"
                  className="service-image img-fluid mb-3"
                  style={{ width: "100%", height: "200px", objectFit: "cover" }}
                />
                <h3 className="service-title" style={{ fontFamily: "Playfair Display, serif" }}>
                  Pietre Preziose
                </h3>
                <p>Scopri la bellezza delle pietre selezionate.</p>
                <Link to="/stones" className="btn btn-outline-dark" style={{ marginTop: "auto" }}>
                  Scopri
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* social */}
      <section style={{ backgroundColor: "#F6F6F6", padding: "60px 0", textAlign: "center" }}>
        <Container>
          {/* <h2
            className="about-subtitle"
            style={{
              fontFamily: "Playfair Display, serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i className="fab fa-instagram" style={{ marginRight: "10px" }}></i>
            starblackgioielli
          </h2> */}
          <h2
            className="about-subtitle"
            style={{
              fontFamily: "Playfair Display, serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src="/assets/ig.png" alt="Instagram" style={{ width: "40px", height: "40px", marginRight: "10px" }} />
            starblackgioielli
          </h2>

          <div className="divider mb-4" style={{ backgroundColor: "#b3870b" }}></div>
          <Row className="instagram-gallery">
            {[
              {
                src: "/assets/primo-post.png",
                alt: "Descrizione 1",
                instagramLink:
                  "https://www.instagram.com/p/DA-fPSsImcy/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
              },
              {
                src: "/assets/secondo-post.png",
                alt: "Descrizione 2",
                instagramLink:
                  "https://www.instagram.com/p/DA5VoX3vFu8/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
              },
              {
                src: "/assets/terzo-post.png",
                alt: "Descrizione 3",
                instagramLink:
                  "https://www.instagram.com/p/DAxnQkACRNI/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
              },
              {
                src: "/assets/quarto-post.png",
                alt: "Descrizione 4",
                instagramLink:
                  "https://www.instagram.com/p/C_XfbnMvY17/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
              },
              {
                src: "/assets/quinto-post.png",
                alt: "Descrizione 5",
                instagramLink:
                  "https://www.instagram.com/p/C_SV0xOP1i3/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
              },
              {
                src: "/assets/sesto-post.png",
                alt: "Descrizione 6",
                instagramLink:
                  "https://www.instagram.com/p/C_NTmGmoXwn/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
              },
            ].map((image, index) => (
              <Col key={index} xs={6} sm={4} md={3} className="instagram-image mb-4">
                <a href={image.instagramLink} target="_blank" rel="noopener noreferrer">
                  <img src={image.src} alt={image.alt} className="img-fluid" />
                </a>
              </Col>
            ))}
          </Row>
          <a href="https://www.instagram.com/starblackgioielli/" target="_blank" rel="noopener noreferrer">
            <button
              className="btn btn-primary"
              style={{ marginTop: "20px", backgroundColor: "#b3870b", color: "white", border: "none" }}
            >
              Seguici su Instagram
            </button>
          </a>
        </Container>
      </section>
    </>
  );
};

export default Home;
